var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout md-alignment-center-center callback-container"},[_c('h3',[_vm._v("Your email was verified, redirecting you soon...")]),_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }